export default __webpack_public_path__ + "static/media/1.48a85cf5.jpg";